import { domain, i18n } from 'arm-common';
import * as agui from 'arm-gui/dist/controls';
import * as React from 'react';
import { connect } from 'react-redux';
import Rest from '../../webapi/Rest';
import DocumentiActions from '../documenti/DocumentiActions';
import CaricaPdf from './CaricaPdf.jsx';
import RinominaCampi from './RinominaCampi.jsx';
import MergePdf from './MergePdf.jsx';

class Utilities extends React.Component {
    constructor(props) {
        super(props);
        this.componentName = "[Upload.jsx] ";
        this.salvaDoc = this.salvaDoc.bind(this);
        this.modificaDoc = this.modificaDoc.bind(this);
        this.elimDoc = this.elimDoc.bind(this);
        this.handleChange = this.handleChange.bind(this);

        this.state = {
            showConfirmSalvaDoc: false
        };
    }

    componentDidMount() {
        console.log(this.componentName + ' componentDidMount')
    }

    changeSelectedTab(idTab) {
        this.props.changeSelectedTab(idTab);
    }

    salvaDoc() {
        if (this.props.validationDocument()) {
            this.setState({ showConfirmSalvaDoc: true });
        }
    }

    salvaDocum() {
        this.props.salvaDoc().then(
            resolve => {
                this.setState({ showConfirmSalvaDoc: false })
                this.props.setIsInEditMode(false);
                this.props.setIsAlreadyExistingDoc(true);
                this.props.getDocumentById(resolve.id);
                this.props.handleNuovoDoc(!toggleNuovoDoc);
            }
        )
    }

    modificaDoc() {
        this.props.inizializzaModificaDocument().then(
            resolve => {
                this.props.setIsInEditMode(true);
            }
        )
    }

    elimDoc() {
        this.props.eliminaDoc().then(
            resolve => {
                this.props.history.goBack();
            }
        )
    }

    handleChange(id, value, tipo) {
        let validation = this.state.validation;
        if (validation.has(id)) {
            validation.delete(id);
            this.setState({ validation: validation });
        }
        this.props.handleChangeDoc(id, value, tipo);
    }

    componentWillUnmount() {
        this.props.setIsInEditMode(false);
        this.props.setIsAlreadyExistingDoc(false);
        this.props.resetDoc();
    }

    preview() {
        this.props.preview().then(
            resolve => {
                // this.props.getDocumentById(this.props.nuovoDoc.id)
            }
        )
    }

    componentWillUnmount() {
        this.props.riInzializzaUtilities();
    }
    render() {
        const { nuovoDoc, handleChangeDoc, isAlreadyExistingDoc, isInEditMode } = this.props;
        const baseUrl = Rest.restBaseurl;

        return (

            <div className="mt-3">
                <agui.aCard>
                    <agui.aCardHeader>
                        <p>{isAlreadyExistingDoc ? (isInEditMode ? i18n('ARM_CORE_PRINT.MODIFICA_DOCUMENTO', `Modifica Documento con id ${nuovoDoc.id}`) : i18n('ARM_CORE_PRINT.DETTAGLIO_DOCUMENTO', `Dettaglio di Documento con id ${nuovoDoc.id}`)) : i18n('ARM_CORE_PRINT.UTILITIES', 'Utilities')}</p>
                    </agui.aCardHeader>
                    <br />

                    <agui.aCardBody className='nuovoDoc'>
                        <div>

                            <ul className="nav nav-tabs ml-3 main-tabs" id="myTab" role="tablist">
                                <li className="active" >
                                    <a className={this.props.tabSelected === "doc-tab" ? "nav-link active" : "nav-link"} id="doc-tab" data-toggle="tab" href="#docTab" role="tab" aria-controls="docTab" aria-selected="true" onClick={() => this.changeSelectedTab('doc-tab')} >{i18n('ARM_CORE_PRINT.STAMPA_FIELDS', 'Stampa nomi campi')}</a>
                                </li>
                                <li className="nav-item">
                                    <a className={this.props.tabSelected === "rinomina-tab" ? "nav-link active" : "nav-link"} id="rinomina-tab" data-toggle="tab" href="#dataSourceTab" role="tab" aria-controls="rinominaTab" aria-selected="true" onClick={() => this.changeSelectedTab('rinomina-tab')}>{i18n('ARM_CORE_PRINT.RENAME_FIELDS', 'Rinomina campi')}</a>
                                </li>
                                <li className="nav-item">
                                    <a className={this.props.tabSelected === "mergePdf-tab" ? "nav-link active" : "nav-link"} id="mergePdf-tab" data-toggle="tab" href="#mergePdf" role="tab" aria-controls="mergePdfTab" aria-selected="true" onClick={() => this.changeSelectedTab('mergePdf-tab')}>{i18n('ARM_CORE_PRINT.MERGE_PDF', 'Merge PDF')}</a>
                                </li>
                            </ul>

                            <div style={{minHeight: '155px'}} className="tab-document-content" id="TabDocumentContent">

                                <div className={this.props.tabSelected === 'doc-tab' ? 'tab-pane active' : 'tab-pane d-none'} id="doc-tab" role="tabpanel" aria-labelledby="doc-tab">
                                    <CaricaPdf />
                                </div>

                                <div className={this.props.tabSelected === 'rinomina-tab' ? 'tab-pane active mr-3' : 'tab-pane d-none'} id="rinomina-tab" role="tabpanel" aria-labelledby="rinomina-tab">
                                    {/* <table ref="ListDataSource" /> */}
                                    <RinominaCampi />
                                </div>

                                <div className={this.props.tabSelected === 'mergePdf-tab' ? 'tab-pane active mr-3' : 'tab-pane d-none'} id="mergePdf-tab" role="tabpanel" aria-labelledby="mergePdf-tab">
                                    <MergePdf />
                                </div>

                            </div>
                        </div>

                        <agui.AskConfirm
                            show={this.state.showConfirmSalvaDoc}
                            options={{
                                title: "Salva Documento",
                                message: "Confermi il salvataggio del documento?",
                                warning: true,
                                yes: "Si",
                                no: "Annulla",
                            }}
                            onConfirm={() => {
                                this.salvaDocum();
                            }}
                            onCancel={() => this.setState({ showConfirmSalvaDoc: false })}
                        />

                    </agui.aCardBody >

                    <agui.aCardFooter>
                        <agui.LineBar>
                            <agui.LineBarGroup right={true}>
                                <agui.aButton bs='secondary' onClick={() => this.props.history.goBack()}>
                                    {i18n('ARM_CORE_PRINT.SHARED.INDIETRO', 'Indietro')}
                                </agui.aButton>
                            </agui.LineBarGroup>
                        </agui.LineBar>
                    </agui.aCardFooter>

                </agui.aCard >
            </div >
        );
    }
}


function mapDispatchToProps(dispatch) {
    return {
        handleChangeDoc(id, value, tipo) {
            return dispatch(DocumentiActions.handleChangeDoc(id, value, tipo));
        },
        salvaDoc() {
            return dispatch(DocumentiActions.salvaDoc());
        },
        removeFile(fileIdx, name) {
            return dispatch(DocumentiActions.removeFile(fileIdx, name));
        },
        changeSelectedTab(idTab) {
            return dispatch(DocumentiActions.changeSelectedTab(idTab));
        },
        getDataSourceLista() {
            return dispatch(DocumentiActions.getDataSourceLista());
        },
        setIsInEditMode(mod) {
            return dispatch(DocumentiActions.setIsInEditMode(mod));
        },
        eliminaDoc() {
            return dispatch(DocumentiActions.eliminaDoc());
        },
        setIsAlreadyExistingDoc(isAlreadyExistingDoc) {
            return dispatch(DocumentiActions.setIsAlreadyExistingDoc(isAlreadyExistingDoc));
        },
        resetDoc() {
            return dispatch(DocumentiActions.resetDoc());
        },
        scaricaDocument(id) {
            return dispatch(DocumentiActions.scaricaDocument(id));
        },
        getDocumentById(docId) {
            return dispatch(DocumentiActions.getDocumentById(docId));
        },
        inizializzaModificaDocument() {
            return dispatch(DocumentiActions.inizializzaModificaDocument())
        },
        handleChangeParameter(key, value) {
            return dispatch(DocumentiActions.handleChangeParameter(key, value))
        },
        preview() {
            return dispatch(DocumentiActions.stampaPreview())
        },
        validationDocument(key, value) {
            return dispatch(DocumentiActions.validationDocument(key, value))
        },
        resetDocTab() {
            return dispatch(DocumentiActions.resetDocTab())
        },
        riInzializzaUtilities() {
            return dispatch(DocumentiActions.riInzializzaUtilities())
        }

    }
};

function mapStateToProps(state) {
    return {
        listaDoc: state.documentiReducer.listaDoc,
        nuovoDoc: state.documentiReducer.nuovoDoc,
        tabSelected: state.documentiReducer.tabSelected,
        listaDataSource: state.documentiReducer.listaDataSource,
        isAlreadyExistingDoc: state.documentiReducer.isAlreadyExistingDoc,
        isInEditMode: state.documentiReducer.isInEditMode,
        parametersMap: state.documentiReducer.parametersMap,
        validationDoc: state.documentiReducer.validationDoc
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Utilities);
